import {
  Button,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  Wrap,
  useToast,
} from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { IoTrashOutline } from 'react-icons/io5';
import { getCurrentToken, handleAuthentication } from '../../../services/Admin/AuthService';
import { deleteOwnBooking } from '../../../services/Admin/OwnerService';
import { OwnBookingsBookings, OwnBookingsBookingsData } from '../../../types/AdminTypes';
import moment from 'moment';
import { ObjectsParams } from '../../../types/ParamsTypes';
import { BookingEditParams } from '../../../types/BookingTypes';

interface DeleteModalProps {
  objectSelected: OwnBookingsBookingsData;
  bookingToDelete: OwnBookingsBookings;
  handleDirtyObjects: (value: boolean) => void;
  handleTokenState: (value: string | null) => void;
  objectsParams: ObjectsParams;
  handleDateRange: (updatedObjectsParams: ObjectsParams) => void;
  handleBookingEditParams: (values: BookingEditParams) => void;
}

export const DeleteModal = (props: DeleteModalProps): JSX.Element => {
  const toast = useToast();
  const {
    objectSelected,
    bookingToDelete,
    handleDirtyObjects,
    handleTokenState,
    objectsParams,
    handleBookingEditParams,
    handleDateRange,
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();

  const ADMIN_DETAILS = 'ADMIN_DETAILS';
  const deleteBooking = useCallback(async () => {
    try {
      await handleAuthentication(ADMIN_DETAILS, handleTokenState);

      const token = getCurrentToken(ADMIN_DETAILS);
      const Booking = bookingToDelete.uniqueId;
      await deleteOwnBooking(Booking, token);
      handleDateRange({
        ...objectsParams,
        fromDate: undefined,
        toDate: undefined,
      });
      handleBookingEditParams({
        booking: '',
        BookingComment: '',
        initialMonth: undefined,
      });
      handleDirtyObjects(true);
    } catch {
      toast({
        position: 'top-right',
        title: 'Buchung konnte nicht gelöscht werden.',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }

    onClose();
  }, [objectSelected, bookingToDelete]);

  return (
    <>
      <IconButton
        mr={1}
        icon={<IoTrashOutline />}
        aria-label={'delete booking'}
        variant="ghost"
        colorScheme={'blue'}
        onClick={onOpen}
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Löschen</ModalHeader>
          <ModalBody>
            <Wrap lineHeight={1}>
              <Text>Sind Sie sicher das Sie die Buchung von</Text>{' '}
              <Text fontWeight={'semibold'}>
                {moment(bookingToDelete.arrivalDate).format('DD.MM.YYYY')} bis{' '}
                {moment(bookingToDelete.departureDate).format('DD.MM.YYYY')}
              </Text>
              <Text>löschen möchten?</Text>
            </Wrap>
          </ModalBody>
          <ModalCloseButton />
          <ModalBody display={'flex'} justifyContent={'flex-end'}>
            <Button colorScheme="blue" mr={3} onClick={deleteBooking}>
              Löschen
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
